<template>
  <v-layout align-center column>
    <p class="title-a">How We Work at Dompet Kilat</p>
    <div>
      <v-skeleton-loader
        type="image"
        class="Dompetkilat-Image"
        v-if="!isImgLoaded"
      ></v-skeleton-loader>
      <img
        src="../../assets/career/Keterbukaan-Value.png"
        @load="onImgLoad"
        class="Dompetkilat-Image"
      />
      <div class="Desc-Box">
        <p class="Title">
          Keterbukaan
        </p>
        <p class="Desc">
          Keterbukaan komunikasi akan memberikan dampak positif bagi setiap
          rekan kerja. Semua suara akan dihargai di sini.
        </p>
      </div>
    </div>
    <div>
      <v-skeleton-loader
        type="image"
        class="Dompetkilat-Image"
        v-if="!isImgLoaded"
      ></v-skeleton-loader>
      <img
        src="../../assets/career/Kebaruan-Value.png"
        @load="onImgLoad"
        class="Dompetkilat-Image"
      />
      <div class="Desc-Box">
        <p class="Title">
          Kebaruan
        </p>
        <p class="Desc">
          Kami berkomitmen untuk menyelesaikan tantangan dengan cara baru.
          Sebagai start-up, kami ingin mendisrupsi sistem yang kurang efisien.
        </p>
      </div>
    </div>
    <div>
      <v-skeleton-loader
        type="image"
        class="Dompetkilat-Image"
        v-if="!isImgLoaded"
      ></v-skeleton-loader>
      <img
        src="../../assets/career/Ketekunan-Value.png"
        @load="onImgLoad"
        class="Dompetkilat-Image"
      />
      <div class="Desc-Box">
        <p class="Title">
          Ketekunan
        </p>
        <p class="Desc">
          Jadikan kesalahan sebagai kesempatan untuk belajar. Ubah apa yang
          tidak berfungsi. Beradaptasi dengan positif.
        </p>
      </div>
    </div>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      isImgLoaded: false,
    };
  },

  methods: {
    onImgLoad() {
      this.isImgLoaded = true;
    },
  },
};
</script>

<style scoped>
.title-a {
  width: 328px;
  flex-grow: 0;
  margin: 46px 0 10px;
  font-family: Sora;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}

.Title {
  font-family: Sora;
  font-style: normal;
  font-weight: bold;
  font-size: 32px;
  line-height: 40px;
  letter-spacing: -0.03em;
  color: #252525;
}

.Desc {
  flex-grow: 0;
  font-family: Sora;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.62;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
}

.Desc-Box {
  width: 328px;
  flex-grow: 0;
  margin: 16px 0 0;
  font-family: Sora;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.62;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
}

.Desc .text-style-1 {
  font-weight: bold;
}
.Dompetkilat-Image {
  width: 327.8px;
  height: 204.1px;
  flex-grow: 0;
  margin: 32px 0.2px 0 0;
  object-fit: contain;
}
</style>
